const SORT_ASC = 0;
const SORT_DESC = 1;

function cellText(row, index) {
  return row.cells[index].textContent.trim();
}

function columnIsNumeric(tbody, index) {
  const rows = Array.from(tbody.rows);
  return (
    rows.length > 0 &&
    rows.every((row) => {
      const value = cellText(row, index);
      return value === '' || !Number.isNaN(Number(value));
    })
  );
}

function compareValues(a, b, numeric) {
  if (numeric) {
    return (parseFloat(a) || 0) - (parseFloat(b) || 0);
  }
  return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
}

function buildComparator(tbody, sortList) {
  const numericByColumn = new Map();
  const isNumeric = (index) => {
    if (!numericByColumn.has(index)) {
      numericByColumn.set(index, columnIsNumeric(tbody, index));
    }
    return numericByColumn.get(index);
  };
  return (rowA, rowB) => {
    for (const [index, direction] of sortList) {
      const cmp = compareValues(
        cellText(rowA, index),
        cellText(rowB, index),
        isNumeric(index),
      );
      if (cmp !== 0) {
        return direction === SORT_DESC ? -cmp : cmp;
      }
    }
    return 0;
  };
}

function applySort(table, sortList) {
  const tbody = table.tBodies[0];
  const rows = Array.from(tbody.rows);
  rows.sort(buildComparator(tbody, sortList));
  rows.forEach((row) => tbody.appendChild(row));
}

function updateHeaderIndicator(
  headers,
  activeIndex,
  direction,
  cssAsc,
  cssDesc,
) {
  headers.forEach((header, index) => {
    header.classList.remove(cssAsc, cssDesc);
    if (index === activeIndex) {
      header.classList.add(direction === SORT_DESC ? cssDesc : cssAsc);
    }
  });
}

// Minimal replacement for the tablesorter jQuery plugin: click-to-sort
// headers (numeric or text, auto-detected per column) plus an optional
// multi-column default sort applied on load. Options mirror the subset of
// tablesorter's API this project actually used, so templates barely change.
export function initSortableTable(tableId, options = {}) {
  const {
    sortList = [],
    cssAsc = 'up',
    cssDesc = 'down',
    sortInitialOrder = 'desc',
  } = options;
  const table = document.getElementById(tableId);
  if (!table || !table.tHead || table.tBodies.length === 0) {
    return;
  }

  const headers = Array.from(table.tHead.rows[0].cells);
  const firstClickDirection = sortInitialOrder === 'asc' ? SORT_ASC : SORT_DESC;

  headers.forEach((header, index) => {
    header.style.cursor = 'pointer';
    header.addEventListener('click', () => {
      const current = header.dataset.sortDirection;
      const direction =
        current === undefined
          ? firstClickDirection
          : Number(current) === SORT_ASC
            ? SORT_DESC
            : SORT_ASC;
      headers.forEach((h) => delete h.dataset.sortDirection);
      header.dataset.sortDirection = String(direction);
      applySort(table, [[index, direction]]);
      updateHeaderIndicator(headers, index, direction, cssAsc, cssDesc);
    });
  });

  if (sortList.length > 0) {
    applySort(table, sortList);
    const [primaryIndex, primaryDirection] = sortList[0];
    headers[primaryIndex].dataset.sortDirection = String(primaryDirection);
    updateHeaderIndicator(
      headers,
      primaryIndex,
      primaryDirection,
      cssAsc,
      cssDesc,
    );
  }
}
